import React from "react";

const Spinner = () => {
  return (
    <div>
      <div className="laoder-container">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Spinner;
